module.exports = {
  default: {
    title: 'Jual Beli dan Investasi Emas Antam Online Terpercaya',
    description:
      'Jual dan beli emas murni/logam mulia Antam 24 karat bersertifikat. Investasi emas dengan mudah secara online di BukaEmas, cek harga hari ini dan beli sekarang!',
    desktop: 'https://www.bukalapak.com/bukaemas',
    mobile: 'https://m.bukalapak.com/bukaemas',
    image: 'https://s4.bukalapak.com/ast/midas/opengraph_banner.png',
    site_name: 'Bukalapak',
    app: 'android-app://com.bukalapak.android/https/www.bukalapak.com//bukaemas',
  },
  'harga-emas-hari-ini': {},
};
